module.exports = __webpack_public_path__ + "static/img/qcCode.0a12013.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImages/qcCode.png
// module id = 3OTQ
// module chunks = 21